import { CaseFeedbackGuidanceMessage, FlexibleTestingTestCaseFeedback, Maybe } from "types/graphql";

export const getUniqueFeedbackCodes = (feedback: Maybe<Array<FlexibleTestingTestCaseFeedback>> | undefined) => {
  const uniqueValues: string[] = [];

  feedback?.forEach(({ value }) => {
    value?.forEach(code => {
      if (!uniqueValues.includes(code)) {
        uniqueValues.push(code);
      }
    });
  });

  return uniqueValues;
};

export const hasRepeatedFeedback = (feedback: FlexibleTestingTestCaseFeedback[]) => {
  const testCaseFeedbackValues = feedback.flatMap(({ value }) => value);

  return new Set(testCaseFeedbackValues).size < testCaseFeedbackValues.length;
};

export const generateTitlesFromFeedback = (
  feedback: string[],
  caseFeedbackGuidanceMessages: CaseFeedbackGuidanceMessage[],
): string[] => {
  const guidanceTitles: string[] = [];

  feedback.forEach(feedbackCode => {
    const guidanceMessage = caseFeedbackGuidanceMessages.find(({ code }) => code === feedbackCode);
    if (guidanceMessage) {
      guidanceTitles.push(guidanceMessage.title);
    }
  });

  return guidanceTitles;
};

export const generateMessagesFromFeedback = (
  feedback: string[],
  caseFeedbackGuidanceMessages: CaseFeedbackGuidanceMessage[],
): string[] => {
  const guidanceMessages: string[] = [];

  feedback.forEach(feedbackCode => {
    const guidanceMessage = caseFeedbackGuidanceMessages.find(({ code }) => code === feedbackCode);
    if (guidanceMessage) {
      guidanceMessages.push(guidanceMessage.message);
    }
  });

  return guidanceMessages;
};

export const formatMessages = (messages: string[]) => {
  const length = messages.length;

  if (length === 1) {
    return ` ${messages[0]}`;
  } else if (length === 2) {
    return ` ${messages[0]} and that ${messages[1]}`;
  } else if (length >= 3) {
    const allButLast = messages.slice(0, -1).join(", ");
    const lastMessage = messages[length - 1];

    return ` ${allButLast}, and that ${lastMessage}`;
  }

  return "";
};
